export const EXPECTED_TIMES_ONCE = [
  {
    /* TRANSLATORS: Form option for volop time commitment */
    name: getText('A few minutes'),
    id: 'FEW_MINUTES',
  },
  {
    /* TRANSLATORS: Form option for volop time commitment */
    name: getText('A few hours'),
    id: 'FEW_HOURS',
  },
  {
    /* TRANSLATORS: Form option for volop time commitment */
    name: getText('A few days'),
    id: 'FEW_DAYS',
  },
  {
    /* TRANSLATORS: Form option for volop time commitment */
    name: getText('A few weeks'),
    id: 'FEW_WEEKS',
  },
  {
    /* TRANSLATORS: Form option for volop time commitment */
    name: getText('Flexible'),
    id: 'FLEXIBLE',
  },
];
